// extracted by mini-css-extract-plugin
export default {"cardIcon":"CardIcon-module__cardIcon--LLEfa","clickable":"CardIcon-module__clickable--BbJjG","subtle":"CardIcon-module__subtle--_butb"};